import { render, staticRenderFns } from "./GradesQuizSelections.vue?vue&type=template&id=8fa2c798"
import script from "./GradesQuizSelections.vue?vue&type=script&lang=js"
export * from "./GradesQuizSelections.vue?vue&type=script&lang=js"
import style0 from "./GradesQuizSelections.vue?vue&type=style&index=0&id=8fa2c798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports